import React from "react";
import BaseGrid from "Components/Fragment/BaseGrid";
import { Box } from "Components/Base/Layout/Box";
import { Badge } from "Components/Base/DataDisplay/Badge";
import InputTextSearch from "./components/InputTextSearch";
import TotalProgressSection from "./components/TotalProgressSection";
import ToggleButtonGroupFilter from "./components/ToggleButtonGroupFilter";
import DrawerFilters from "./components/DrawerFilters";
import ToggleButtonGroupViewType from "../ToggleButtonGroupViewType";
import SelectFilter from "./components/SelectFilter";
import * as CONSTANTS from "../../constants";
import { useFilter } from "./context";

const PageFilter = ({ languageContext }) => {
  const {
    state,
    setFilterStatus,
    setSortBy,
    setSearchText,
    onSearch,
    hitCount,
    showHitCount,
  } = useFilter();

  return (
    <>
      <BaseGrid
        childWidth="auto"
        justifyContent="space-between"
        alignItems="center"
      >
        <BaseGrid childWidth="auto" alignItems="center">
          <SelectFilter
            className="filter-sort-select"
            name={languageContext("status")}
            options={CONSTANTS.SORT_OPTIONS_STATUS}
            value={state?.status ? state.status.toLowerCase() : ""}
            onChange={setFilterStatus}
            languageContext={languageContext}
            displayLabel={false}
            sx={{ height: "46px" }}
            translateOptions={true}
          />
          <SelectFilter
            className="filter-sort-select"
            name={languageContext("sort")}
            options={CONSTANTS.SORT_OPTIONS_ORDER}
            value={state?.sortBy ? state.sortBy.toLowerCase() : ""}
            onChange={setSortBy}
            languageContext={languageContext}
            displayLabel={false}
            sx={{ height: "46px" }}
            translateOptions={true}
          />
          <InputTextSearch
            searchText={state.searchText}
            setSearchText={setSearchText}
            onSearch={onSearch}
            languageContext={languageContext}
          />
          <Badge
            badgeContent={hitCount && showHitCount ? hitCount : 0}
            color="primary"
          >
            <ToggleButtonGroupFilter
              languageContext={languageContext}
              displayClearButton={showHitCount}
            />
          </Badge>
          <ToggleButtonGroupViewType
            labels={[languageContext("ListView"), languageContext("imageview")]}
          />
        </BaseGrid>
        <Box>
          <TotalProgressSection languageContext={languageContext} scale={1} />
        </Box>
      </BaseGrid>
      <DrawerFilters
        hitCount={hitCount}
        showHitCount={showHitCount}
        languageContext={languageContext}
      />
    </>
  );
};

export default PageFilter;
